import { User } from '~/store/user/models';
import { createAsyncAction } from 'typesafe-actions';

enum USER_ACTION_TYPE {
    GET_USER_DATA_REQUEST = '@user/GET_USER_DATA_REQUEST',
    GET_USER_DATA_SUCCESS = '@user/GET_USER_DATA_SUCCESS',
    GET_USER_DATA_FAILURE = '@user/GET_USER_DATA_FAILURE',
}

export const getUserDataActions = createAsyncAction(
    USER_ACTION_TYPE.GET_USER_DATA_REQUEST,
    USER_ACTION_TYPE.GET_USER_DATA_SUCCESS,
    USER_ACTION_TYPE.GET_USER_DATA_FAILURE
)<void, User, { error: Error }>();
